import React, { useEffect, useState } from "react";
import BoxListHolder from "../boxListHolder/BoxListHolder";
import { forArrayLength } from "../misc/helperfuncs";
import collectionStore from "./../stores/collectionStore";

const SelectedTypesList = ({ selectedCollection, boxTypes }) => {
  const [boxes, setBoxes] = useState([]);
  const { open, saved } = collectionStore();

  // take the boxTypes and get all objects from the selectedCollection
  function populateBoxes() {
    const obj = { open, saved };
    var objects = [];
    forArrayLength(boxTypes, (boxType) => {
      const array = obj[selectedCollection][boxType.names.plural];
      objects = objects.concat(array);
    });
    console.log("objects - ", objects);
    setBoxes(objects);
  }
  useEffect(() => {
    if (selectedCollection != "history") populateBoxes();
  }, [open, saved, selectedCollection, boxTypes]);

  return (
    <div
      className="divColumn"
      style={{ height: "100%", width: "100%", justifyContent: "start" }}
    >
      <div
        style={{
          border: "1px dashed #2f2f2f",
          width: "60%",
          marginTop: "15px",
        }}
      />
      <div
        className="divColumn"
        style={{
          height: "100%",
          overflow: "auto",
          width: "80%",
          marginTop: "2px",
        }}
      >
        {boxes.map((b) => (
          <BoxListHolder box={b} key={b.id} />
        ))}
      </div>
    </div>
  );
};

export default SelectedTypesList;
